import React, { useState } from "react";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import { CircleImg, FooterContainer, FooterGrid } from "../styles/footer";
import { Link } from "react-router-dom";
import { LinearLine } from "../styles/porfolio";
import FooterImg from "../assets/footer.jpg";
import resume from "../assets/resume.pdf";
import { useLocation } from "react-router-dom";
import { CVButton, WindowBlack } from "../styles/home";
import { StyledArrow } from "../components/arrow";

const Footer = () => {
  const [color, setColor] = useState("");
  const coloring = (e) => {
    setColor(e);
  };
  const location = useLocation();
  const isContact = location.pathname === "/contact";
  return (
    <WindowBlack>
      <FooterContainer>
        <h1>Available for freelance work</h1>
        <LinearLine></LinearLine>
        <FooterGrid>
          <CircleImg src={FooterImg} alt="Image" />
          <div>
            <p style={{ color: "white", fontWeight: "bold", fontSize: "30px" }}>
              Are You Ready to kickstart your project with a touch of magic?
            </p>
            <p>the.mechanic99@bk.ru</p>
            <p>+821082547679</p>
            <Link
              onClick={(e) => coloring("contact")}
              disabled={color === "contact"}
              style={{ textDecoration: "none" }}
              to="/contact"
            >
              {!isContact ? (
                <button>
                  Let's Talk <ConnectWithoutContactIcon />
                </button>
              ) : (
                <CVButton href={resume} download={"Resume-Ilyosjon"}>
                  <p>
                    Download CV{" "}
                    <div>
                      <StyledArrow />
                    </div>
                  </p>
                </CVButton>
              )}
            </Link>
          </div>
        </FooterGrid>
        <LinearLine style={{ background: "gray" }}></LinearLine>
      </FooterContainer>
    </WindowBlack>
  );
};

export default Footer;
